import { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

export function SlideCarousel({ items, render, prefix, label }) {
  const [api_, setApi] = useState(null);
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (!api_) return;
    const on = () => setIdx(api_.selectedScrollSnap());
    on(); api_.on("select", on); api_.on("reInit", on);
    return () => { api_.off("select", on); api_.off("reInit", on); };
  }, [api_]);
  return (
    <div data-testid={`${prefix}-carousel`}>
      <Carousel setApi={setApi} opts={{ align: "center" }} className="max-w-md mx-auto">
        <CarouselContent>
          {items.map((it) => <CarouselItem key={it.id}>{render(it)}</CarouselItem>)}
        </CarouselContent>
        {items.length > 1 && <><CarouselPrevious className="hidden sm:flex" data-testid={`${prefix}-prev`} /><CarouselNext className="hidden sm:flex" data-testid={`${prefix}-next`} /></>}
      </Carousel>
      {items.length > 1 && (
        <div className="flex items-center justify-center gap-1.5 mt-4" data-testid={`${prefix}-dots`}>
          {items.map((it, i) => (
            <button key={it.id} type="button" aria-label={`${label} ${i + 1}`} onClick={() => api_?.scrollTo(i)}
              className={`h-2 rounded-full transition-[width,background-color] ${i === idx ? "w-6 bg-primary" : "w-2 bg-primary/25"}`} />
          ))}
          <span className="text-xs text-muted-foreground ml-2" data-testid={`${prefix}-counter`}>{Math.min(idx + 1, items.length)} de {items.length}</span>
        </div>
      )}
    </div>
  );
}
